<template>
  <div>
    <form id="formulario_login">
      <h2 id="title_login">Já sou cliente</h2>
      <input type="message" id="form_login" v-model="email" placeholder="E-mail" />
      <br />
      <input type="password" id="form_login" v-model="senha" placeholder="Senha" />
      <router-link to="/esquecisenha">
        <p id="esqueci_pass_txt">Esqueci minha senha</p>
      </router-link>
      <p v-if="mensagem">{{mensagem}}</p>
      <p v-if="mensagem_err">{{mensagem_err}}</p>
      <button type="button" v-on:click="login()">Entrar</button>
    </form>

    <!-- <form id="formulario_login">
      <h2 id="title_login">Criar conta</h2>
      <input type="message" id="form_login" placeholder="E-mail" v-model="create_email" />
      <br />
      <button type="button" @click="openCadastrar()" name>Cadastrar</button>
    </form> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data: () => ({
    email: "",
    senha: "",
    create_email: "",
    mensagem: "",
    mensagem_err: "",
    retorno: null
  }),
  beforeMount() {
    let user = JSON.parse(localStorage.getItem("usuario"));

    if (user) {
      this.$router.push("account");
    }
  },
  methods: {
    async login() {
      if (this.email && this.senha) {
        let info = null;
        let infor = {
          query: "none",
          country: "none",
          region: "none",
          city: "none"
        };
        try {
          info = await axios.get("http://ip-api.com/json?callback=?");
          if (info) {
            infor = JSON.parse(info.data.slice(2, -2));
          } else {
            infor = {
              query: "none",
              country: "none",
              region: "none",
              city: "none"
            };
          }
        } catch (err) {
          infor = {
            query: "none",
            country: "none",
            region: "none",
            city: "none"
          };
        }
        await this.$http
          .post("/projects/authenticate-client", {
            email: this.email,
            senha: this.senha,
            address: infor.query,
            country: infor.country,
            region: infor.region,
            city: infor.city
          })
          .then(async res => {
            this.mensagem_err = "";

            this.retorno = res;
            const save = JSON.stringify(res.data);
            localStorage.setItem("usuario", save);
            await this.sendInfo();
            if (this.$route.query.l === "true") {
              this.$router.push("/checkout");
            } else {
              this.$router.push("/account");
            }
          })
          .catch(err => {
            this.mensagem_err = err.error;
          });
      }
    },
    async sendInfo() {
      try {
        let dados = JSON.parse(localStorage.getItem("uiid"));
        if (!dados) {
          let info = await axios.get("http://ip-api.com/json?callback=?");

          if (info) {
            let infor = JSON.parse(info.data.slice(2, -2));

            let user = JSON.parse(localStorage.getItem("usuario"));

            let user_ = null;

            if (user && user.user && user.user._id) {
              user_ = user.user._id;
            }

            await this.$http
              .post("/opens/control/add", {
                address: infor.query,
                country: infor.country,
                region: infor.region,
                city: infor.city,
                place: "WC",
                user: user_
              })
              .then(res => {
                localStorage.setItem("uiid", res.data._id);
              })
              .catch(err => {
                console.log(err);
              });
          }
        } else {
          let info = await axios.get("http://ip-api.com/json?callback=?");

          if (info) {
            let infor = JSON.parse(info.data.slice(2, -2));

            let user = JSON.parse(localStorage.getItem("usuario"));

            let user_ = null;

            if (user && user.user && user.user._id) {
              user_ = user.user._id;
            }

            await this.$http
              .put(`/opens/control/${dados}`, {
                address: infor.query,
                country: infor.country,
                region: infor.region,
                city: infor.city,
                place: infor.place,
                user: user_
              })
              .then(res => {
                localStorage.setItem("uiid", res.data._id);
              })
              .catch(() => {});
          }
        }
      } catch (err) {
        console.log("Well...");
      }
    },
    openCadastrar() {
      if (this.create_email) {
        this.$router.push(`/cadastrar?e=${this.create_email}`);
      }
    }
  }
};
</script>

<style>
#formulario_login {
  margin-top: 40px;
}

#title_login {
  margin-top: 20px;
  font-size: 20px;
}

#esqueci_pass_txt {
  font-size: 14px;
  margin-top: 10px;
  color: #191919;
}

#formulario_login input {
  width: 30%;
  border-radius: 10px;
  margin-top: 10px;
  font-size: 16px;
  border: 1px solid #e4e4e4;
  padding: 10px;
}

#formulario_login button {
  width: 20%;
  margin-top: 20px;
  margin-bottom: 40px;
  background-color: #191919;
  border: none;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;
  font-size: 14px;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}

@media screen and (max-width: 800px) {
  #formulario_login {
  }

  #formulario_login input {
    width: 80%;
    border-radius: 10px;
    margin-top: 10px;
    font-size: 16px;
    border: 1px solid #e4e4e4;
    padding: 10px;
  }

  #formulario_login button {
    width: 80%;
    margin-top: 20px;
    margin-bottom: 40px;
    background-color: #191919;
    border: none;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 10px;
    font-size: 14px;
    color: #ffffff;
    font-weight: 700;
    cursor: pointer;
  }
}
</style>
